import {
  setCertificadosAction,
  setCertificadosPropsAction,
  setLoadingDetallePolizaAction,
  setPlanSeleccionadoAction,
  setShowFormAddCertificadoAction,
  setStateDetallePolizaAction,
} from 'redux/actions/detallePoliza.action';

const { handleActions } = require('redux-actions');

const initialState = {
  poliza: null,
  planSeleccionado: null,
  showFormAddCertificado: false,
  loadingDetallePoliza: true,
  certificadosProps: null,
  certificados: [],
};

const detallePolizaReducer = handleActions(
  {
    [setStateDetallePolizaAction]: (state, { payload }) => ({
      ...state,
      ...payload,
    }),
    [setPlanSeleccionadoAction]: (state, { payload }) => ({
      ...state,
      planSeleccionado: payload,
    }),
    [setShowFormAddCertificadoAction]: (state, { payload }) => ({
      ...state,
      showFormAddCertificado: payload,
    }),
    [setLoadingDetallePolizaAction]: (state, { payload }) => ({
      ...state,
      loadingDetallePoliza: payload,
    }),
    [setCertificadosPropsAction]: (state, { payload }) => ({
      ...state,
      certificadosProps: payload,
    }),
    [setCertificadosAction]: (state, { payload }) => ({
      ...state,
      certificados: payload,
    }),
  },
  initialState,
);

export default detallePolizaReducer;
